export default __webpack_public_path__ + "static/media/slider-1.dcc1699e.jpg";